import React from 'react';

import { BoldText, DangerText, InfoText } from './Components/ContractText';

interface Props {
  settlementDate?: string;
  buyerName?: string;
  sellerName?: string;
  financingCommitmentDate?: string;
  mortgageCompany?: string;
  escrowAgent?: string;
  taxDate?: string;
}

const SettlementAndPossession = ({
  settlementDate,
  buyerName,
  sellerName,
  financingCommitmentDate,
  mortgageCompany,
  escrowAgent,
  taxDate,
}: Props) => (
  <>
    <h2 className="text-xl font-bold uppercase mt-8 mb-2 border-b pb-1">
      Settlement and Posession
    </h2>
    <ol className="text-black mb-4 text-base list-decimal list-inside">
      <li>
        The Settlement Date is on {settlementDate} or before if Buyer and Seller
        agree.
      </li>
      <li>
        Settlement will occur in the county where the Property is located or in
        an adjacent county, during normal business hours, unless Buyer and
        Seller agree otherwise.
      </li>
      <li>
        At time of settlement, the following will be pro-rated on a daily basis
        between Buyer and Seller, reimbursing where applicable: Current Taxes,
        rents; interest on mortgage assumptions; condominium fees and homeowner
        association fees; water and/or sewer fees, together with any other
        lienable municipal service fees. All charges will be prorated for the
        period(s) covered. Seller will pay up to and including the date of
        settlement and Buyer will pay for all days following settlement, unless
        otherwise stated here.
      </li>
      <li>
        For purposes of prorating real estate taxes, the Seller made the most
        recent tax payment: {taxDate ?? 'N/A'}
      </li>
      <li>
        For purposes of marketable title, the seller's mortgage company is:{' '}
        <span className="font-bold text-blue-700 bg-blue-50 px-1 rounded-sm">
          {mortgageCompany}
        </span>
      </li>
      <li>
        For purposes of Seller closing documentation signing, the seller's
        elects as their escrow agent is:{' '}
        <span className="font-bold text-blue-700 bg-blue-50 px-1 rounded-sm">
          {escrowAgent}
        </span>
      </li>
      <li>
        Conveyance from Seller will be by fee simple deed of special warranty
        unless otherwise stated.
      </li>
      <li>Seller will pay all transfer taxes and or document stamp taxes.</li>
      <li>
        Possession is to be delivered by deed, existing keys and physical
        possession to a vacant Property free of debris, with all structures
        broom-clean, at day and time of settlement.
      </li>
      <li>
        Buyer shall pay the Purchase Price in cash at date and time of
        settlement.
      </li>
    </ol>
  </>
);

export default SettlementAndPossession;
